var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-output',{attrs:{"errors":_vm.errors}},[_c('a-checkbox-group',{class:['checkboxes readOnly', { readOnly: _vm.readOnly }],attrs:{"disabled":_vm.disabled || _vm.readOnly,"options":_vm.selectOptions},model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }